/**
@format
@flow
*/
import React from 'react';
import { Popover as KrispyPopover } from '@krispy/popovers/web';
import type { TextLinkType } from '@ziynx/flow-types/links';

type Props = $ReadOnly<{|
  links?: Array<TextLinkType>,
  position: 'bottomRight' | 'bottomLeft' | 'topRight' | 'topLeft',
  trigger: any,
  children?: any,
  /**
   * Set open state of popover if desired, else default to state behavior
   * Click must occur before popover appears otherwise position does not calculate.
   */
  open?: boolean,
|}>;

const List = (props: Props): React$Node => (<KrispyPopover {...props} />);

export default List;
